import React from 'react';

import { openReactActionDialog, ReactActionDialogBodyProps } from '~commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { Messages } from '~src/codegen/Localize';
import { DomainUpdateType, IUpdateBaasEdgePoolResult } from '~src/settings/dataconnect-settings/serverApi/requests/UpdateBaasEdgePoolRequest';
import { BaasEdgePoolAndCluster } from '~src/settings/dataconnect-settings/serverApi/resources/BaasEdgePoolAndCluster';

import { ActionItemInfo } from '../../MoreActionsMenu';
import { DomainID } from '../../types/Domain';
import { PoolAssignmentOption } from '../../types/PoolAssignmentOption';
import { PoolID } from '../../types/PoolID';
import { getGeneralErrorMessage } from '../../utils/EdgePoolErrorUtilities';
import { createPoolOptionsFromPools } from '../../utils/PoolModelUtilities';
import { MoveDomainDialogBody } from './MoveDomainDialogBody';


export function openMoveDomainDialog(
  onMoveDomainDialogSave: (domainName: DomainID, poolID: PoolID) => void,
  poolOptions: ReadonlyArray<PoolAssignmentOption>,
  poolID: PoolID,
  domainName: DomainID
) {
  const action = (_props: MoveDomainDialogInputProps, state: MoveDomainDialogState) => {
    onMoveDomainDialogSave(_props.domainName, state.poolID);
    return Promise.resolve();
  };
  const dialogInstance = openReactActionDialog({
    title: Messages.dataConnectSiteSettingsMoveDomainTitle(),
    bodyComponent: MoveDomainDialog,
    initialBodyProps: { poolOptions, domainName},
    initialDialogState: { poolID: poolID},
    actionName: Messages.save(),
    action: action,
    isActionDelete: false,
    dialogWidth: TabDialogWidth.width375px,
    dismissDialogOnActionFailed: false
  });

  return Promise.resolve(dialogInstance.result);
}

export type MoveDomainDialogInputProps = Readonly<{
  poolOptions: ReadonlyArray<PoolAssignmentOption>;
  domainName: DomainID;
}>;

export type MoveDomainDialogState = Readonly<{
  poolID: PoolID;
}>;

export type MoveDomainDialogProps = ReactActionDialogBodyProps<
  MoveDomainDialogInputProps,
  MoveDomainDialogState
>;

export const MoveDomainDialog = (props: MoveDomainDialogProps): JSX.Element => {

  const setAssignedPoolID = (changedPoolID: PoolID | null) => props.updateDialogState({ poolID: changedPoolID });

  const onDomainPoolAssignmentChange = (changedPoolID: PoolID | null) => {
    setAssignedPoolID(changedPoolID);
  };

return (
    <MoveDomainDialogBody
      domainName={props.domainName}
      onPoolAssignmentChange={onDomainPoolAssignmentChange}
      assignedPoolID={props.dialogState.poolID}
      poolOptions={props.poolOptions}
    />
  );
};

export function openMovePoolDomainDialog(actionItem: ActionItemInfo) {

  const onMoveDomainDialogSave = (domainName: string, newAssignedPoolID: PoolID) => {

    BaasEdgePoolAndCluster.updateBaasPool({
      poolId: actionItem.poolId,
      displayName: null,
      domainChange: { change: DomainUpdateType.Remove, domainId: actionItem.domain.domainName  as DomainID},
      DataConnectSettingsVersion: '0'
    }).then((resultForRemove: IUpdateBaasEdgePoolResult) => {
      if (resultForRemove.errors) {
        ToasterService.instance.pop({
          type: ToastType.Error,
          text: getGeneralErrorMessage(resultForRemove.errors[0].code, resultForRemove.errors[0].message)
        });
      }
      if (resultForRemove.success) {
        BaasEdgePoolAndCluster.updateBaasPool({
          poolId: newAssignedPoolID,
          displayName: null,
          domainChange: { change: DomainUpdateType.Add, domainId: domainName as DomainID },
          DataConnectSettingsVersion: '0'
        })
          .then((resultForAdd: IUpdateBaasEdgePoolResult) => {
            actionItem.refreshPoolsAndClusters();
            if (resultForAdd.success) {
              ToasterService.instance.pop({ type: ToastType.Success, text: Messages.dataConnectSiteSettingsMoveDomainSuccess() });
            }
            if (resultForAdd.errors) {
              ToasterService.instance.pop({
                type: ToastType.Error,
                text: getGeneralErrorMessage(resultForAdd.errors[0].code, resultForAdd.errors[0].message)
              });
            }
          });
      }
    });
  };

  const poolOptions: ReadonlyArray<PoolAssignmentOption> = createPoolOptionsFromPools(actionItem.userDefinedPools);

  openMoveDomainDialog(onMoveDomainDialogSave, poolOptions, actionItem.poolId, actionItem.domain.domainName as DomainID);
}
